import type { IHandlerType } from "./controls/base/IHandlerType";
import { Name } from "./controls/profile-page/Name";
import { AdminNavigationBar } from "./controls/AdminNavigationBar";
import { Birthday } from "./controls/profile-page/Birthday";
import { ChildProfileInfoBlockEdit } from "./controls/profile-page/ChildProfileInfoBlockEdit";
import { EndFriendshipButton } from "./controls/profile-page/EndFriendshipButton";
import { StatusMessageEditor } from "./controls/texteditor/StatusMessageEditor";
import { LoginFormParent } from "./controls/LoginFormParent";
import { ForgotPasswordParent } from "./controls/ForgotPasswordParent";
import { BootstrapSlider } from "./controls/form/BootstrapSlider";
import { ToggleableControl } from "./controls/toggleable/ToggleableControl";
import { ChildCredentials } from "./parent-controls/ChildCredentials";
import { FeatureLevelSelect } from "./controls/form/FeatureLevelSelect";
import { FeatureLevelSettings } from "./parent-controls/FeatureLevelSettings";
import { NewspaperAdSaveButton } from "./controls/NewspaperAdSaveButton";
import { PasswordInputGroup } from "./controls/form/PasswordInputGroup";
import { ChangePassword } from "./parent-controls/ChangePassword";
import { ProfileEmailChange } from "./controls/ProfileEmailChange";
import { ChildProfile } from "./controls/profile-page/ChildProfile";

const handlerTypes: { [name: string]: IHandlerType } = {
	AdminNavigationBar,
	Birthday,
	ChildProfileInfoBlockEdit,
	Name,
	EndFriendshipButton,
	StatusMessageEditor,
	LoginFormParent,
	ForgotPasswordParent,
	BootstrapSlider,
	ToggleableControl,
	ChildCredentials,
	FeatureLevelSelect,
	FeatureLevelSettings,
	NewspaperAdSaveButton,
	PasswordInputGroup,
	ChangePassword,
	ProfileEmailChange,
	ChildProfile,
};

export function initializeJQueryHandlerTypes() {
	for (const [name, handlerType] of Object.entries(handlerTypes)) {
		jQuery(`[data-handler-type="${name}"]`).map((index: number, elem: HTMLElement) => new handlerType(jQuery(elem)));
	}
}
